window.addEventListener('DOMContentLoaded', function () {
    const page = document.getElementById('js-products-list');
    if (!page) return;

    const deleteItemId = page.dataset.deleteItemId;
    const deleteMsg = page.dataset.deleteMsg;

    $(function () {
        clearFilters();

        function clearFilters() {
            $('#btn_filters_clear').on('click', function (e) {
                e.preventDefault();
                var form = $('#frm_list_filter');
                form.find("select[name='search_form[category]']").val('');
                const typeSelect = form.find("select[name='search_form[type]']");
                if (!typeSelect.prop('disabled')) {
                    typeSelect.val('');
                }
                form.find("select[name='search_form[agree_status]']").val('');
                form.find("select[name='search_form[public_status]']").val('');
                form.find("input[name='search_form[manufacturer]']").val('');
                form.find("input[name='search_form[product_name]']").val('');
                form.find("input[name='search_form[model_number]']").val('');
                form.find("input[name='search_form[include_deleted]']").prop('checked', false);
            });
        }

        $("a[pid='" + deleteItemId + "']").on('click', async function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            if (url === '#') return;
            const result = await window.showConfirm(deleteMsg);
            if (result) {
                window.location.href = url;
            }
        });
    });
});
